import { RRModalButtonsModel } from './modal-buttons.model';

export class RRModalModel {
  id?: string | number;
  title?: string;
  text?: string;
  class?: string;
  modalClass?: string;
  buttons?: RRModalButtonsModel[];
  noButtons?: boolean;
  match?: string;
  bodyClass?: string;
  disableCloseButton?: boolean;
  ignoreBackdropClick?: boolean;
  backdrop?: boolean | 'static';
  keyboard?: boolean;
  transitionTime?: number;
}
